import React from 'react';

function Rank (props) {
  return (
    <div>rank</div>
  )
}

export default React.memo (Rank);